import carriersByInsuranceTypeSelector from './carriersByInsuranceTypeSelector';
import { createSelector } from 'reselect';

const carriersSelector = createSelector(
    carriersByInsuranceTypeSelector,
    (state, insuranceType) => insuranceType,
    (carriersByInsuranceType, insuranceType) =>
        carriersByInsuranceType[insuranceType]
);

export default carriersSelector;
